<template>
  <v-navigation-drawer
    :value="is_not_desktop ? !is_mini_sidebar : false"
    :permanent="!is_not_desktop"
    :width="!is_mini_sidebar ? sidebar_width : sidebar_mini_width"
    floating
    fixed
    app
    :touchless="true"
    :class="$style.sidebar"
  >
    <template>
      <div :class="[$style.sidebar_header, is_mini_sidebar ? $style.sidebar_header_mini : $style.sidebar_header_full, is_mobile ? $style.sidebar_header_mobile : $style.sidebar_header_mini]">
        <v-btn
          icon
          :class="[is_not_desktop ? $style.toggle_btn_mobile : $style.toggle_btn]"
          @click="toggle_sidebar(!is_mini_sidebar)"
        >
          <v-icon
            v-if="is_mini_sidebar"
            :class="$style.toggle_btn_icon"
          >
            mdi-chevron-right
          </v-icon>
          <v-icon
            v-else
            :class="$style.toggle_btn_icon"
          >
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <div
          :class="$style.sidebar_head"
        >
          <LogoWhite
            v-if="is_mini_sidebar"
            class="mr-4"
            :class="$style.logo"
            @click="to_main_page"
          />
          <div
            v-else
            :class="$style.logo_wrap"
            @click="to_main_page"
          >
            <LogoWhite class="mr-4" />
            <span
              :class="$style.logo_text"
            >ЛКП</span>
          </div>
        </div>
      </div>

      <!-- Главаня -->
      <v-list-item
        :to="{ path: '/' }"
        :exact-active-class="$style.activeLink"
        :class="$style.listItem"
        v-slot="{ active }"
        exact-path
      >
        <v-list-item-content :class="$style.pin_item_menu">
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex; gap: 24px">
              <v-tooltip
                right
                color="primary darken-3"
                :open-delay="300"
                :disabled="!is_mini_sidebar"
                nudge-right="20"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <v-icon
                    :class="[active ? $style.activeIcon : '']"
                    v-bind="attrs"
                    v-on="on"
                  >{{ main_menu_icon }}</v-icon>
                </template>
                <span>
                  Главная
                </span>
              </v-tooltip>
              <div class="d-flex justify-space-between align-center">
                <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">Главная
                </v-list-item-title>
              </div>
            </div>
          </div>
        </v-list-item-content>
      </v-list-item>

      <!-- Избранное -->
      <div>
        <v-list-group
          v-if="favorites_menu.length"
          v-model="favorits_toggle"
        >
          <template v-slot:activator>
            <v-list-item-icon
              style="margin-right: 24px;"
            >
              <v-tooltip
                right
                color="primary darken-3"
                :open-delay="300"
                :disabled="!is_mini_sidebar"
                nudge-right="20"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <div
                    v-bind="attrs"
                    v-on="on"
                  >
                    <SidebarItemIcon
                      icon="mdi-bookmark-check-outline"
                      :has-badge="false"
                    />
                  </div>
                </template>
                <span>
                  Избранное
                </span>
              </v-tooltip>
              <SidebarItemIcon
                v-if="favorits_toggle && is_mini_sidebar"
                icon="mdi-chevron-up"
                :has-badge="false"
              />
              <SidebarItemIcon
                v-if="!favorits_toggle && is_mini_sidebar"
                icon="mdi-chevron-down"
                :has-badge="false"
              />
            </v-list-item-icon>
            <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">Избранное</v-list-item-title>
          </template>

          <div v-if="favorites_menu.length">
            <v-list-item
              v-for="item in favorites_menu"
              :key="item.title"
              v-slot="{ active }"
              :class="[ $style.listItem, is_link_active(item.slug) ? $style.activeLink : '' ]"
              :to="to_links(item.slug)"
              :exact-active-class="$style.activeLink"
              exact-path
            >
              <v-tooltip
                right
                color="primary darken-3"
                :open-delay="300"
                :disabled="!is_mini_sidebar"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <v-list-item-content
                    v-bind="attrs"
                    v-on="on"
                    :class="$style.pin_item_menu"
                  >
                    <div
                      class="d-flex justify-space-between align-center"
                      style="height: 24px;"
                    >
                      <div style="display: flex; gap: 24px">
                        <div
                          style="width: 24px;"
                          class="d-flex justify-start"
                          :class="is_mini_sidebar ? '' : 'ml-4'"
                        >
                          <v-icon :class="[active ? $style.activeIcon : '']">{{ get_icon(item) }}</v-icon>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">{{ item.title }}
                          </v-list-item-title>
                        </div>
                      </div>

                      <div v-if="item.tag">
                        <v-chip
                          class="chip-tag"
                          :color="item.tag.color_area"
                          :text-color="item.tag.color_name"
                        >
                          {{ item.tag.name }}
                        </v-chip>
                      </div>

                      <div
                        v-if="item.is_favorite"
                        :class="$style.pin_favorite"
                        @click.prevent.stop="delete_favorites(item)"
                      >
                        <v-icon
                          size="24"
                          color="primary darken-3"
                        >
                          mdi-bookmark
                        </v-icon>
                      </div>
                      <div
                        v-if="!item.is_favorite"
                        :class="$style.pin_favorite"
                        @click.prevent.stop="add_favorites(item)"
                      >
                        <v-icon
                          size="24"
                          color="primary darken-3"
                        >
                          mdi-bookmark-outline
                        </v-icon>
                      </div>
                    </div>
                  </v-list-item-content>
                </template>
                <span>
                  {{ item.title }}
                </span>
              </v-tooltip>
            </v-list-item>
          </div>
        </v-list-group>

        <v-list-item v-if="!is_mini_sidebar && !favorites_menu.length">
          <v-list-item-content class="py-4">
            <div :class="$style.open_favorites_menu">
              <div style="display: flex; gap: 24px">
                <SidebarItemIcon
                  icon="mdi-bookmark-check-outline"
                  :has-badge="false"
                />
                <div class="d-flex justify-space-between align-center">
                  <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">Избранное
                  </v-list-item-title>
                </div>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>

        <!-- Избранное (пустое) для мини сайдбара -->
        <v-list-item v-if="is_mini_sidebar && !favorites_menu.length">
          <v-list-item-content class="py-4">
            <div :class="$style.open_favorites_menu">
              <div style="display: flex; gap: 24px">
                <v-tooltip
                  right
                  color="primary darken-3"
                  :open-delay="300"
                  :disabled="!is_mini_sidebar"
                  nudge-right="20"
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <div
                      v-bind="attrs"
                      v-on="on"
                    >
                      <SidebarItemIcon
                        icon="mdi-bookmark-check-outline"
                        :has-badge="false"
                      />
                    </div>
                  </template>
                  <span>
                    Избранное
                  </span>
                </v-tooltip>
                <div class="d-flex justify-space-between align-center">
                  <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">Избранное
                  </v-list-item-title>
                </div>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </div>

      <!-- Основное меню -->
      <div
        :class="$style.separator_menu"
      >
        <v-list
          v-for="(item, idx) in main_menu"
          :key="idx"
          class="pa-0"
          :class="$style.menu_list"
        >
          <v-list-item
            v-if="item.sub_menu.length === 0 && item.slug !== 'main_page'"
            v-slot="{ active }"
            :class="$style.listItem"
            :to="to_links(item.slug)"
            :exact-active-class="$style.activeLink"
            exact-path
          >
            <v-tooltip
              right
              color="primary darken-3"
              :open-delay="300"
              :disabled="!is_mini_sidebar"
            >
              <template
                v-slot:activator="{ on, attrs }"
              >
                <v-list-item-content
                  v-bind="attrs"
                  v-on="on"
                  :class="$style.pin_item_menu"
                >
                  <div style="display: flex; justify-content: space-between; align-items: center; height: 24px;">
                    <div style="display: flex; gap: 24px">
                      <v-icon :class="[active ? $style.activeIcon : '']">{{ get_icon(item) }}</v-icon>
                      <div
                        class="aaaaa d-flex justify-space-between align-center"
                        style="height: 100%;"
                      >
                        <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">{{ item.title }}
                        </v-list-item-title>
                      </div>
                    </div>
                    <div
                      class="d-flex align-center"
                      style="gap: 8px"
                    >
                      <div
                        v-if="item.notifications"
                        :class="$style.badge_wrapper"
                      >
                        <div
                          v-if="!item.hover"
                          :class="$style.badge"
                        >
                          {{ item.notifications }}
                        </div>
                      </div>
                      <div v-if="item.tag">
                        <v-chip
                          class="chip-tag"
                          :color="item.tag.color_area"
                          :text-color="item.tag.color_name"
                        >
                          {{ item.tag.name }}
                        </v-chip>
                      </div>
                      <div
                        v-if="item.is_favorite"
                        :class="$style.pin_favorite"
                        @click.prevent.stop="delete_favorites(item)"
                      >
                        <v-icon
                          size="24"
                          color="primary darken-3"
                        >
                          mdi-bookmark
                        </v-icon>
                      </div>
                      <div
                        v-if="!item.is_favorite"
                        :class="$style.pin_favorite"
                        @click.prevent.stop="add_favorites(item)"
                      >
                        <v-icon
                          size="24"
                          color="primary darken-3"
                        >
                          mdi-bookmark-outline
                        </v-icon>
                      </div>
                    </div>
                  </div>
                </v-list-item-content>
              </template>
              <span>
                {{ item.title }}
              </span>
            </v-tooltip>
          </v-list-item>

          <!-- Подменю -->
          <v-list-group
            v-if="item.sub_menu.length > 0"
            v-model="item.active"
          >
            <template v-slot:activator>
              <div>
                <v-list-item-icon style="margin-right: 24px;">
                  <v-tooltip
                    right
                    color="primary darken-3"
                    :open-delay="300"
                    :disabled="!is_mini_sidebar"
                    nudge-right="20"
                  >
                    <template
                      v-slot:activator="{ on, attrs }"
                    >
                      <div
                        v-bind="attrs"
                        v-on="on"
                      >
                        <SidebarItemIcon
                          :icon="get_icon(item)"
                          :has-badge="item.notifications ? true : false"
                        />
                      </div>
                    </template>
                    <span>
                      {{ item.title }}
                    </span>
                  </v-tooltip>
                  <SidebarItemIcon
                    v-if="item.active && is_mini_sidebar"
                    icon="mdi-chevron-up"
                    :has-badge="false"
                  />
                  <SidebarItemIcon
                    v-if="!item.active && is_mini_sidebar"
                    icon="mdi-chevron-down"
                    :has-badge="false"
                  />
                </v-list-item-icon>
              </div>
              <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">{{ item.title }}</v-list-item-title>
            </template>

            <div
              v-for="sub_item in item.sub_menu"
              :key="sub_item.id"
            >
              <v-list-item
                v-if="is_router_link(sub_item)"
                v-slot="{ active }"
                :class="[ $style.listItem, is_link_active(sub_item.slug) ? $style.activeLink : '' ]"
                :to="to_links(sub_item.slug)"
                :exact-active-class="$style.activeLink"
                exact-path
              >
                <v-tooltip
                  right
                  color="primary darken-3"
                  :open-delay="300"
                  :disabled="!is_mini_sidebar"
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-list-item-content
                      v-bind="attrs"
                      v-on="on"
                      :class="$style.pin_item_menu"
                    >
                      <div
                        class="d-flex justify-space-between align-center"
                        style="height: 24px;"
                      >
                        <div style="display: flex; gap: 24px">
                          <div
                            class="d-flex justify-start"
                            style="width: 24px;"
                            :class="is_mini_sidebar ? '' : 'ml-4'"
                          >
                            <v-icon :class="[active ? $style.activeIcon : '']">{{ get_icon(sub_item) }}</v-icon>
                          </div>
                          <div class="d-flex justify-space-between align-center">
                            <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">{{ sub_item.title }}
                            </v-list-item-title>
                          </div>
                        </div>

                        <div
                          class="d-flex align-center"
                          style="gap: 8px"
                        >
                          <div
                            v-if="sub_item.notifications"
                            :class="$style.badge_wrapper"
                          >
                            <div
                              v-if="!sub_item.hover"
                              :class="$style.badge"
                            >
                              {{ sub_item.notifications }}
                            </div>
                          </div>

                          <div v-if="sub_item.tag">
                            <v-chip
                              class="chip-tag"
                              :color="sub_item.tag.color_area"
                              :text-color="sub_item.tag.color_name"
                            >
                              {{ sub_item.tag.name }}
                            </v-chip>
                          </div>

                          <div
                            v-if="sub_item.is_favorite"
                            :class="$style.pin_favorite"
                            @click.prevent.stop="delete_favorites(sub_item)"
                          >
                            <v-icon
                              size="24"
                              color="primary darken-3"
                            >
                              mdi-bookmark
                            </v-icon>
                          </div>
                          <div
                            v-if="!sub_item.is_favorite"
                            :class="$style.pin_favorite"
                            @click.prevent.stop="add_favorites(sub_item)"
                          >
                            <v-icon
                              size="24"
                              color="primary darken-3"
                            >
                              mdi-bookmark-outline
                            </v-icon>
                          </div>
                        </div>

                      </div>
                    </v-list-item-content>
                  </template>
                  <span>
                    {{ sub_item.title }}
                  </span>
                </v-tooltip>
              </v-list-item>

              <v-list-item
                v-else
                v-slot="{ active }"
                :class="[ $style.listItem, is_link_active(sub_item.slug) ? $style.activeLink : '' ]"
                @click="link_to(sub_item)"
                :exact-active-class="$style.activeLink"
                exact-path
              >
                <v-tooltip
                  right
                  color="primary darken-3"
                  :open-delay="300"
                  :disabled="!is_mini_sidebar"
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-list-item-content
                      v-bind="attrs"
                      v-on="on"
                      :class="$style.pin_item_menu"
                    >
                      <div
                        class="d-flex justify-space-between align-center"
                        style="height: 24px;"
                      >
                        <div style="display: flex; gap: 24px">
                          <div
                            class="d-flex justify-start"
                            style="width: 24px;"
                            :class="is_mini_sidebar ? '' : 'ml-4'"
                          >
                            <v-icon :class="[active ? $style.activeIcon : '']">{{ get_icon(sub_item) }}</v-icon>
                          </div>
                          <div class="d-flex justify-space-between align-center">
                            <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">{{ sub_item.title }}
                            </v-list-item-title>
                          </div>
                        </div>

                        <div
                          class="d-flex align-center"
                          style="gap: 8px"
                        >
                          <div
                            v-if="sub_item.notifications"
                            :class="$style.badge_wrapper"
                          >
                            <div
                              v-if="!sub_item.hover"
                              :class="$style.badge"
                            >
                              {{ sub_item.notifications }}
                            </div>
                          </div>
                          <div
                            v-if="sub_item.is_favorite"
                            :class="$style.pin_favorite"
                            @click.prevent.stop="delete_favorites(sub_item)"
                          >
                            <v-icon
                              size="24"
                              color="primary darken-3"
                            >
                              mdi-bookmark
                            </v-icon>
                          </div>
                          <div
                            v-if="!sub_item.is_favorite"
                            :class="$style.pin_favorite"
                            @click.prevent.stop="add_favorites(sub_item)"
                          >
                            <v-icon
                              size="24"
                              color="primary darken-3"
                            >
                              mdi-bookmark-outline
                            </v-icon>
                          </div>
                        </div>

                      </div>
                    </v-list-item-content>
                  </template>
                  <span>
                    {{ sub_item.title }}
                  </span>
                </v-tooltip>
              </v-list-item>

            </div>
          </v-list-group>
        </v-list>
      </div>

      <!-- Помощь -->
      <div :class="$style.separator_menu">
        <v-list-group
          v-model="question_toggle"
        >
          <template v-slot:activator>
            <v-list-item-icon style="margin-right: 24px;">
              <v-tooltip
                right
                color="primary darken-3"
                :open-delay="300"
                :disabled="!is_mini_sidebar"
                nudge-right="20"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <div
                    v-bind="attrs"
                    v-on="on"
                  >
                    <SidebarItemIcon
                      :icon="help_menu_icon"
                      :has-badge="false"
                    />
                  </div>
                </template>
                <span>
                  Помощь
                </span>
              </v-tooltip>
              <SidebarItemIcon
                v-if="question_toggle && is_mini_sidebar"
                icon="mdi-chevron-up"
                :has-badge="false"
              />
              <SidebarItemIcon
                v-if="!question_toggle && is_mini_sidebar"
                icon="mdi-chevron-down"
                :has-badge="false"
              />
            </v-list-item-icon>
            <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">Помощь</v-list-item-title>
          </template>

          <div
            v-for="item in help_menu"
            :key="item.id"
          >
            <v-list-item
              v-if="is_router_link(item)"
              v-slot="{ active }"
              :class="$style.listItem"
              :to="to_links(item.slug)"
              :exact-active-class="$style.activeLink"
              exact-path
            >
              <v-tooltip
                right
                color="primary darken-3"
                :open-delay="300"
                :disabled="!is_mini_sidebar"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <v-list-item-content
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div style="display: flex; justify-content: space-between; align-items: center !important;">
                      <div
                        :class="is_mini_sidebar ? '' : 'ml-4'"
                        style="display: flex; gap: 24px"
                      >
                        <SidebarItemIcon
                          :icon="get_icon(item)"
                          :is-active="active"
                          :has-badge="false"
                        />
                        <div>
                          <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">{{ item.title }}
                          </v-list-item-title>
                        </div>
                      </div>
                    </div>
                  </v-list-item-content>
                </template>
                <span>
                  {{ item.title }}
                </span>
              </v-tooltip>
              <div v-if="item.tag">
                <v-chip
                  class="chip-tag"
                  :color="item.tag.color_area"
                  :text-color="item.tag.color_name"
                >
                  {{ item.tag.name }}
                </v-chip>
              </div>
            </v-list-item>

            <v-list-item
              v-else
              v-slot="{ active }"
              :class="$style.listItem"
              @click="link_to(item)"
              :exact-active-class="$style.activeLink"
              exact-path
            >
              <v-tooltip
                right
                color="primary darken-3"
                :open-delay="300"
                :disabled="!is_mini_sidebar"
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <v-list-item-content
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div style="display: flex; justify-content: space-between; align-items: center !important;">
                      <div
                        :class="is_mini_sidebar ? '' : 'ml-4'"
                        style="display: flex; gap: 24px"
                      >
                        <SidebarItemIcon
                          :icon="get_icon(item)"
                          :is-active="active"
                          :has-badge="false"
                        />
                        <div>
                          <v-list-item-title :class="[is_mobile ? $style.menu_text_mobile : $style.menu_text]">{{ item.title }}
                          </v-list-item-title>
                        </div>
                      </div>
                    </div>
                  </v-list-item-content>
                </template>
                <span>
                  {{ item.title }}
                </span>
              </v-tooltip>
              <div v-if="item.tag">
                <v-chip
                  class="chip-tag"
                  :color="item.tag.color_area"
                  :text-color="item.tag.color_name"
                >
                  {{ item.tag.name }}
                </v-chip>
              </div>
            </v-list-item>
          </div>
        </v-list-group>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { global_store, user_store } from '@/store';
import AccountBlankOutline from '@/assets/icons/account-blank-outline.svg?inline';
import PencilRulerOutline from '@/assets/icons/pencil-ruler-outline.svg?inline';
import HandShakeOutline from '@/assets/icons/handshake-outline.svg?inline';
import PiecePaperOutline from '@/assets/icons/piece-paper-outline.svg?inline';
import ArticleOutline from '@/assets/icons/article-outline.svg?inline';
import SafeSearchOutline from '@/assets/icons/safe-search-outline.svg?inline';
import QuestionOutline from '@/assets/icons/question-outline.svg?inline';
import WrenchRoundOutline from '@/assets/icons/wrench-round-outline.svg?inline';
import ImageOutline from '@/assets/icons/image-outline.svg?inline';
import LogoWhite from '@/assets/logo.svg?inline';
import { User } from '@/modules/user/types';
import { MenuLinks, MenuPages } from '@/enums/menu';
import SidebarItemIcon from './SidebarItemIcon.vue';
import { Badge } from '../global/badge';
import { menu_external_links, external_link_names } from './consts';

const global_state = global_store.state;
const global_mutations = global_store.mutations;

@Component({
  components: {
    Badge,
    LogoWhite,
    SidebarItemIcon,
    AccountBlankOutline,
    PencilRulerOutline,
    HandShakeOutline,
    PiecePaperOutline,
    ArticleOutline,
    SafeSearchOutline,
    QuestionOutline,
    WrenchRoundOutline,
    ImageOutline,
    MenuLinks,
  },
})
export default class SidebarApp extends Vue {
  info_card_toggle = false;

  no_favorites_text = 'Разделы, добавленные в избранное, появятся здесь';

  info_items = [
    {
      id: 1,
      title: 'atol.ru',
      icon: 'mdi-web',
      link: 'https://www.atol.ru/',
    },
    {
      id: 2,
      title: '+7 (495) 786-68-36',
      icon: 'mdi-phone',
      link: 'tel:+74957307420',
    },
    {
      id: 3,
      title: 'lkp@atol.ru',
      icon: 'mdi-email-outline',
      link: 'mailto:lkp@atol.ru',
    },
  ]

  get main_menu() {
    return user_store.state.main_menu;
  }

  get main_menu_icon() {
    const item = this.main_menu.find((item) => item.slug === MenuLinks.MAIN_PAGE);

    return item?.icon ? item.icon : 'mdi-home';
  }

  get favorites_menu() {
    return user_store.state.favorites_menu.sub_menu ? user_store.state.favorites_menu.sub_menu : [];
  }

  get help_menu() {
    return user_store.state.help_menu.sub_menu ? user_store.state.help_menu.sub_menu : [];
  }

  get help_menu_icon() {
    return user_store.state.help_menu.icon || 'mdi-help-circle-outline';
  }

  @Watch('is_mini_sidebar', { immediate: true })
  close_favorites_menu() {
    if (this.is_mini_sidebar && this.favorites_menu.length === 0) {
      this.favorits_toggle = false;
    }
  }

  @Watch('is_mobile', { immediate: true })
  on_is_mobile_change(is_mobile: boolean) {
    if (is_mobile) {
      global_store.state.sidebar_width = '100%';
    } else {
      global_store.state.sidebar_width = '300px';
    }
  }

  to_links(slug: string | null) {
    if (!slug) {
      return '';
    }
    return { path: MenuLinks[slug] };
  }

  is_link_active(slug: string) {
    const { path } = this.$route;

    return path === MenuLinks[slug];
  }

  open_info() {
    if (!this.is_mini_sidebar) {
      this.info_card_toggle = !this.info_card_toggle;
    }
  }

  toggle_sidebar(value: boolean) {
    global_store.mutations.SIDEBAR_TOGGLE(value);
  }

  handle_mouse_enter(item: User.MainMenuItem) {
    if (!item.hover) {
      this.$set(item, 'hover', true);
      return;
    }
    item.hover = true;
  }

  handle_mouse_leave(item: User.MainMenuItem) {
    item.hover = false;
  }

  touchless = true;

  @Watch('is_mini_sidebar', { immediate: true })
  on_change() {
    if (this.is_mini_sidebar) {
      this.info_card_toggle = false;
    }
  }

  created() {
    if (this.is_not_desktop) {
      global_mutations.SIDEBAR_TOGGLE(true);
    }
  }

  visibility_check(value: string) {
    const { available_pages } = user_store.state.me;
    const active_el = available_pages.find((sub_item) => sub_item.slug === value);

    if (active_el && !active_el.is_active) {
      return false;
    } return true;
  }

  mounted() {
    const sbr_mounted = localStorage.getItem('is_mini_sidebar');

    if (sbr_mounted) {
      global_mutations.SIDEBAR_TOGGLE(JSON.parse(sbr_mounted));
    }
  }

  get favorits_toggle() {
    return global_state.favorits_toggle;
  }

  set favorits_toggle(value: boolean) {
    global_store.mutations.UPD_FAVORITS_TOOGLE(value);
  }

  get question_toggle() {
    return global_state.question_toggle;
  }

  set question_toggle(value: boolean) {
    global_store.mutations.UPD_QUESTION_TOGGLE(value);
  }

  get_icon(item: User.MainMenuItem) {
    return item.icon ? item.icon : 'mdi-circle-outline';
  }

  get is_not_desktop() {
    return global_state.isTablet || global_state.isMobile;
  }

  get is_mobile() {
    return global_state.isMobile;
  }

  get is_mini_sidebar() {
    return global_state.is_mini_sidebar;
  }

  get sidebar_width() {
    return global_state.sidebar_width;
  }

  get sidebar_mini_width() {
    return global_state.sidebar_mini_width;
  }

  get user_roles() {
    return user_store.getters.me_shared.roles.map((e) => e.slug);
  }

  get contact_information_path() {
    return global_store.state.contact_information_path;
  }

  get user_guide_link() {
    return global_store.state.user_guide_path;
  }

  is_router_link(item: User.MainMenuItem) {
    if (external_link_names.includes(item.slug)) {
      return false;
    }

    return true;
  }

  link_to(item: User.MainMenuItem) {
    /**
     * внешние ссылки в меню
     */

    if (item.slug === MenuPages.CONTACT_INFORMATION) {
      window.open(this.contact_information_path, '_blank');
      return;
    }

    if (item.slug === MenuPages.DOWNLOAD_CENTER) {
      window.open(menu_external_links.download_center_link, '_blank');
      return;
    }

    if (item.slug === MenuPages.USER_GUIDE) {
      window.open(this.user_guide_link, '_blank');
      return;
    }

    if (item.slug === MenuPages.TELEPHONE) {
      window.open(`tel:${menu_external_links.telephone}`, '_blank');
      return;
    }

    if (item.slug === MenuPages.E_MAIL) {
      window.open(`mailto:${menu_external_links.e_mail}`, '_blank');
      return;
    }

    if (item.slug === MenuPages.WEBSITE) {
      window.open(menu_external_links.website, '_blank');
      return;
    }

    const link = MenuLinks[item.slug];

    if (this.$route.name === link) {
      return;
    }

    if (link) {
      this.$router.push(link || '');
    }
  }

  add_favorites(item: User.MainMenuItem) {
    if (!item.is_favorite) {
      user_store.actions.add_favorite(item);
    }
  }

  delete_favorites(item: User.MainMenuItem) {
    if (item.is_favorite) {
      user_store.actions.delete_favorite(item);
    }
  }

  to_main_page() {
    if (this.$route.path !== MenuLinks[MenuPages.MAIN]) {
      this.$router.push({ path: MenuLinks[MenuPages.MAIN] });
    }
  }
}
</script>

<style module lang="scss">
.sidebarBtnWrap {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid $primary_lighten4 !important;
}

.sidebarBtn {
  margin-left: 7px;
}

.list {
  padding: 2px 0;
}

.listItem {
  overflow: hidden;
  color: #696c86 !important;
  font-weight: 500;

  &:hover {
    background-color: transparrent !important;
  }

  &.wide {
    padding-left: 8px;
    margin-left: 0;
    margin-right: 16px;
    padding-right: 12px;
  }

  &:before {
      content: '';
      opacity: 1 !important;
      position: absolute;
      left: 0;
      top: 8px;
      width: 4px;
      height: 32px;
      background-color: $error_darken4;
      border-radius: 0 24px 24px 0;
      opacity: 0 !important; /* Невидимый по умолчанию */
      transition: all 0.1s ease;
    }

  &.activeLink {
    color: $error_darken4 !important;
    position: relative;
    font-weight: 500;
    font-family: $heading-font-family;

    &:before {
      opacity: 1 !important; /* Делаем видимым */
      background-color: $error_darken4; /* Применяем цвет */
    }

    .itemTitleText {
      font-weight: 500;
    }
  }
}

.activeIcon {
  color: $error_darken4 !important;
}

.listItemTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.divider {
  max-width: 32px;
  margin-left: auto;
  margin-right: auto;

  .opened & {
    max-width: 90%;
  }
}

.arrowIcon {
  transition: transform 0.3s ease;
}

.rotate {
  transform: rotate(180deg);
}

.dropdownItem {
  padding-left: 35px !important;
}

.hovered {
  font-weight: 500;
}

.sidebar_head {
  display: flex;
  align-items: center;
  height: 72px;
  padding-left: 16px;
}

.logo:hover {
  cursor: pointer;
}

.logo_text {
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  font-family: $heading-font-family;
  color: #13141c;
}

.logo_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo_wrap:hover {
  cursor: pointer;
}

.menu_text {
  max-width: 160px !important;
  font-size: 16px !important;
  font-family: $heading-font-family;
  line-height: 24px !important;
}

.menu_text_mobile {
  width: 100%;
  font-size: 16px !important;
}

.badge {
  height: 16px;
  background-color: $error_darken4;
  color: #fff;
  font-family: "CoFo Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-stretch: 100%;
  padding: 2px 6px;
  border-radius: 8px;
}

.separator_menu {
  position: relative;
  padding-top: 8px;
}

.separator_menu:before {
  content: '';
  position: absolute;
  top: 0;
  left: 12px;
  right: 12px;
  border-top: 1px solid #EDEFF5;
}

.pin_favorite {
  display: none !important;
  height: 30px;
  width: 30px;
  border-radius: 8px;
  // display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #EDEFF5;
  }
}

.info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  gap: 24px;
  width: 100%;
  max-width: 100%;
  height: 56px;
  background-color: #FFFFFF;
  color: $primary_darken3;

  &:hover {
    cursor: pointer;
    background-color: #F2F3F6 !important;
  }
}

.info_text {
  font-size: 16px;
  font-family: $heading-font-family;
  color: $primary_darken3;
  font-weight: 500;
}

.info_card {
  position: absolute;
  bottom: 66px;
  height: 300px !important;
  // max-width: 100% !important;
  width: 268px !important;
  box-shadow: 0px 4px 4px 0px #00000040;

  font-size: 16px;
  font-family: $heading-font-family;
  color: $primary_darken3;
}

.info_link {
  text-decoration: none !important;
  color: #696C86 !important;

  &:hover {
    background-color: #F6F6F6;
    border-radius: 8px;
  }
}

.toggle_btn {
  position: absolute;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 24px -2px #13141C29;
  top: 16px;
  right: -20px;
  max-width: 32px;
  max-height: 32px;
  z-index: 1;
}

.toggle_btn_mobile {
  position: absolute;
  background-color: #FFFFFF;
  box-shadow: 0px 4px 24px -2px #13141C29;
  top: 16px;
  right: 16px;
  max-width: 32px;
  max-height: 32px;
  z-index: 1;
}

:global(.v-navigation-drawer) {
  overflow: visible !important;
}

:global(.v-list-item--link:before) {
    &:hover {
      background-color: transparrent !important;
    }
}

:global(.v-list-group__header) {
  color: $primary_darken3 !important;
  font-family: "TT Firs Neue", sans-serif;
  font-weight: 500;
  // color: #13141c !important;
}

:global(.v-list-group .v-list-group--active .primary--text) {
  background: transparent !important;
}

:global(.v-list-item .v-ripple__container) {
  color: #696c86 !important;
}

.sidebar {
  padding-top: 80px !important;

  .no_favorites_text {
    display: block;
    font-family: $heading-font-family;
    font-size: 15px;
    padding: 8px 16px 0 16px !important;
    color: #696c86 !important;
    opacity: 0.8;
  }
}

:global(.v-navigation-drawer.sidebar) {
  padding-top: 80px !important;
}

.sidebar_header {
  position: absolute;
  top: 0;
  background-color: #FFFFFF !important;
  z-index: 9999999;

  &::after {
    content: '';
    position: absolute;
    top: 72px;
    left: 12px;
    right: 12px;
    border-bottom: 1px solid #EDEFF5;
    z-index: 99999999;
  }
}

.sidebar_header_mini {
  width: 80px !important;
  transition-duration: 0.2s !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-property: transform, visibility, width !important;
  transform: translateX(0%);
}

.sidebar_header_full {
  width: 300px !important;
  transition-duration: 0.2s !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-property: transform, visibility, width !important;
  transform: translateX(0%);
}

.sidebar_header_mobile {
  width: 100% !important;
  transition-duration: 0.2s !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-property: transform, visibility, width !important;
  transform: translateX(0%);
}

.open_favorites_menu {
  display: flex !important;
  justify-content: space-between !important;
  opacity: 0.6;
}

.pin_item_menu {
  padding-top: 16px;
  padding-bottom: 16px;
}

.pin_item_menu:hover .pin_favorite {
  display: flex !important;
}

.pin_item_menu:hover .badge_wrapper {
  display: none !important;
}

.badge_wrapper {
  display: flex !important;
}

::-webkit-scrollbar {
  width: 6px !important;
}

::-webkit-scrollbar-thumb {
  background: #BABABA;
  border-radius: 6px;
}

@media (max-width: 599px) {
  ::-webkit-scrollbar {
  width: 0 !important;
  }
}

:global(.chip-tag) {
  max-width: 80px;
  height: 24px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  font-size: 12px !important;
}
</style>
